const metadata = new WeakMap<File, { size: number; type: string }>()
export const pickedFileSize = (file: File): number => metadata.get(file)?.size ?? file.size
export const pickedFileType = (file: File): string => metadata.get(file)?.type ?? file.type

export const referenceFile = (item: {
  storedObjectId: string
  documentId?: string
  name: string
  size: number
  type: string
}): File => {
  const file = new File(
    [JSON.stringify({ storedObjectId: item.storedObjectId, documentId: item.documentId })],
    item.name,
    { type: 'application/x-crm-stored-object' },
  )
  metadata.set(file, { size: item.size, type: item.type })
  return file
}

/** Bun's multipart parser infers MIME from the filename, so references need an explicit sentinel. */
export const appendPickedFile = async (body: FormData, field: string, file: File) => {
  if (file.type !== 'application/x-crm-stored-object') {
    body.append(field, file)
    return
  }
  const reference = JSON.parse(await file.text()) as {
    storedObjectId: string
    documentId?: string
  }
  body.append(
    field,
    new File(
      [JSON.stringify({ ...reference, name: file.name })],
      '__crm_stored_object_reference__',
      { type: 'application/json' },
    ),
  )
}
